import {
  GET_ASSET_URL_FAILURE,
  GET_ASSET_URL_SUCCESS,
} from '../actionConstants';

const getMaskedContactInfo = (contact) => {
  if (!contact || typeof contact !== 'string') return null;
  const atSingIndex = contact.indexOf('@'); // isEmail check
  if (atSingIndex > 0) {
    const shownLocalPart = contact.substring(0, 3);
    const hidenlocalPart = contact
      .substring(3, atSingIndex)
      ?.replace(/./gm, '*');
    const domain = contact.slice(atSingIndex);
    return atSingIndex < 4
      ? `***${domain}`
      : shownLocalPart + hidenlocalPart + domain;
  }
  const lastFourNumbers = contact.substring(contact.length - 4);
  return `(###)###-${lastFourNumbers}`;
};

const getContactType = (contact) => {
  if (!contact || typeof contact !== 'string') return null;
  if (contact.includes('@')) return 'email';
  return 'phoneNumber';
};

const defaultState = {
  assetUrl: '',
  contactInfo: '',
  contactType: '',
  firstName: '',
  errorCode: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_ASSET_URL_SUCCESS: {
      if (!action?.res?.data) return defaultState;
      const { contact, url, firstName } = action.res.data;
      return {
        ...defaultState,
        assetUrl: url,
        contactInfo: getMaskedContactInfo(contact),
        contactType: getContactType(contact),
        firstName,
      };
    }
    case GET_ASSET_URL_FAILURE:
      return {
        ...state,
        errorCode: action?.err?.response?.data?.code,
      };
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
